// src/components/AgeretProductDetail.jsx

import React, { useState } from "react";
import "../assets/css/AgeretProductDetail.css";
import mainImage from "../assets/images/New-Products/hydew-body-lotion.jpg";
import thumb1 from "../assets/images/New-Products/extra/Hydew-Body-loation.jpg";
import thumb2 from "../assets/images/New-Products/hydew-body-lotion.jpg";
import thumb3 from "../assets/images/New-Products/new/hydewBodyLotion.jpeg";
import howToUseThumb from "../assets/images/skin-breadcrum.jpg";
import howToUseVideo from "../assets/Video/meical video.mp4";
import BredcrumpImage from "../assets/images/skin-breadcrum.jpg";
import BreadcrumbSection from "./BreadcrumbSection";



const AgeretProductDetails = () => {
  const [selectedImage, setSelectedImage] = useState(mainImage);
  const [activeTab, setActiveTab] = useState("benefits");
  const [showVideo, setShowVideo] = useState(false);

  return (
    <>

      <BreadcrumbSection
        title="Empowering Confidence Through Skin Health."
        // subtitle="Committed to Excellence:"
        breadcrumbItems={[
          { label: "Home", to: "/" }, { label: "Skin Care", to: "/Skin-Care-Products" },

        ]}
        backgroundImage={BredcrumpImage}
      />

      <section className="product-details-section">

        <div className="container product-container">
          {/* Product Image and Details */}
          <div className="product-info">
            <div className="product-image-section">
              <img src={selectedImage} alt="Ageret Product" className="main-image" />
              <div className="thumbnail-row">
                {[thumb1, thumb2 ,thumb3].map((img, i) => (
                  <img
                    key={i}
                    src={img}
                    alt={`Thumbnail ${i + 1}`}
                    className={`thumbnail ${selectedImage === img ? "active-thumb" : ""}`}
                    onClick={() => setSelectedImage(img)}
                  />
                ))}
              </div>
            </div>

            <div className="product-description">
              <h2>Hydew Body Lotion</h2>
              <p className="sub-heading text-muted">FOR DRY, ITCHY & SENSITIVE SKIN</p>
              <h5>Product Overview</h5>
              <p>
                <ul>
                  <li>Dehydrated skin appears dry, itchy, and dull due to loss of moisture.</li>
                  <li>It often leads to an irresistible desire to scratch and may cause skin injuries.</li>
                  <li>Hydew Body is a combination of essential biomimetic ceramides and is enriched with ingredients that supplement the impaired natural moisturizing elements of the skin.</li>
                </ul>

              </p>
            </div>
          </div>

          {/* How To Use Section */}
          {/* <div className="how-to-use-section" data-aos="fade-up">
            <div
              className="how-to-use-content"
              style={{
                backgroundImage: `url(${howToUseThumb})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div className="text-content">
                <h3>
                  How To Use <span className="highlight">Hydew Body Lotion?</span>
                </h3>
                <p>
                  Dispense the lotion on the palm of your hand. Gently spread it on the dry areas of the skin.
                </p>
              </div>
              <div className="video-thumbnail-wrapper" onClick={() => setShowVideo(true)}>
                <div className="video-thumbnail">
                  <i className="bi bi-play-fill play-icon"></i>
                </div>
              </div>
            </div>
          </div> */}

          {/* Video Popup Modal */}
          {showVideo && (
            <div className="video-popup">
              <div className="video-container">
                <video controls autoPlay>
                  <source src={howToUseVideo} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>

                {/* Uncomment this block to use YouTube later */}
                {/*
              <iframe
                src="https://www.youtube.com/embed/VIDEO_ID?autoplay=1"
                title="How to Use Ageret"
                frameBorder="0"
                allow="autoplay; encrypted-media"
                allowFullScreen
              ></iframe>
              */}

                <button className="close-btn" onClick={() => setShowVideo(false)}>
                  &times;
                </button>
              </div>
            </div>
          )}

          {/* Accordion Section */}
          <div className="accordion-section">
            <div className="accordion-tabs">
              {["benefits", "application", "ingredients"].map((tab) => (
                <button
                  key={tab}
                  className={`accordion-tab ${activeTab === tab ? "active" : ""}`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab === "benefits"
                    ? "BENEFITS"
                    : tab === "application"
                      ? "APPLICATION GUIDELINES"
                      : tab === "ingredients"
                        ? "INGREDIENTS"
                        : "BEFORE–AFTER"}
                </button>
              ))}
            </div>

            <div className="accordion-content">
              {activeTab === "benefits" && (
                <div className="tab-content fade-in">
                  <ul>
                    <li>Softens, soothes, and relieves dry skin.</li>
                    <li>Provides an occlusive and protective barrier on the skin.</li>
                    <li>Reduces itching and irritation.</li>
                    <li>Long-lasting, fragrance-free, non-sensitizing, and non-comedogenic formula.</li>
                  </ul>

                </div>
              )}
              {activeTab === "application" && (
                <div className="tab-content fade-in">
                  <p>
                    <ol>
                      <li>Dispense the lotion on the palm of your hand.</li>
                      <li>Gently spread it on the dry areas of the skin.</li>
                      <li>Apply evenly.</li>
                      <li>Use daily for optimal hydration.</li>
                    </ol>

                  </p>
                </div>
              )}
              {activeTab === "ingredients" && (
                <div className="tab-content fade-in">
                  <p>
                    <ul>
                      <li><strong>SK Influx:</strong> A skin-identical lipid concentrate composed of Ceramide 1, 3 & 6, Cholesterol, fatty acids, and phytosphingosine which is important in maintaining healthy skin. It strengthens the skin barrier and prevents TEWL.</li>

                      <li><strong>Oat Meal Extract:</strong> Helps balance the microbes in your skin, keeping it healthy, while providing soothing and moisturizing effects. It also contains skin-barrier-repairing omega 5 & 6 fatty acids, offering anti-inflammatory benefits.</li>

                      <li><strong>Trehalose:</strong> A resurrection sugar with two glucose molecules obtained from plants, insects, and microbes. It mimics the sugars found in the Natural Moisturizing Factor, effectively drawing in moisture to maintain skin hydration.</li>

                      <li><strong>Essential Oils:</strong> Act as an occlusive and protective barrier. They exhibit anti-inflammatory and anti-bacterial properties.</li>
                    </ul>

                  </p>
                </div>
              )}



            </div>
          </div>
        </div>
      </section>

    </>
  );
};

export default AgeretProductDetails;
